import React from 'react';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SEO from '../components/SEO';
import TrustBar from '../components/TrustBar';

const organizationSchema = {
  '@type': 'Organization',
  '@id': 'https://lsabill.net/#organization',
  url: 'https://lsabill.net/',
  logo: { '@type': 'ImageObject', '@id': 'https://lsabill.net/#logo', url: 'https://lsabill.net/logo.webp', contentUrl: 'https://lsabill.net/logo.webp' },
};

const websiteSchema = {
  '@type': 'WebSite',
  '@id': 'https://lsabill.net/#website',
  url: 'https://lsabill.net/',
  name: 'LSA Bill',
  publisher: organizationSchema,
};

const serviceSchema = {
  '@type': 'Service',
  '@id': 'https://lsabill.net/#customer-care-service',
  name: 'LSA Bill Customer Care Service',
  serviceType: 'Subscription customer care, billing support and cancellation service',
  description: 'Online customer care service for managing subscriptions, accessing subscription information, getting help with billing questions, contacting support agents, and cancelling subscriptions.',
  url: 'https://lsabill.net/',
  provider: { '@id': 'https://lsabill.net/#organization' },
};

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': 'https://lsabill.net/#webpage',
  url: 'https://lsabill.net/',
  name: 'LSA Bill',
  description: 'Manage subscriptions, request cancellations, resolve billing issues, and contact support agents anytime with fast, secure, and reliable assistance.',
  isPartOf: websiteSchema,
  about: serviceSchema,
  publisher: organizationSchema,
};

export default function HomePage() {
  const title = 'Subscription Support & Cancellation Service Online';
  const description =
    'Manage subscriptions, request cancellations, resolve billing issues, and contact support agents anytime with fast, secure, and reliable assistance.';
  const url = 'https://lsabill.net/';

  return (
    <div className="page-shell min-h-screen">
      <SEO
        title={title}
        description={description}
        canonicalUrl={url}
        ogTitle={title}
        ogDescription={description}
        ogUrl={url}
        ogImage="https://lsabill.net/logo.webp"
        twitterTitle="LSA Bill | Subscription Customer Care & Cancellation"
        twitterDescription="LSA Bill provides subscription customer care, account assistance, subscription information, and cancellation support."
        twitterImage="https://lsabill.net/logo.webp"
        schema={homeSchema}
      />
      <Header />
      <main className="pb-6">
        <Hero />
        <TrustBar className="pt-0" />
        <Features className="pt-0" />
      </main>
      <Footer />
    </div>
  );
}
